// extracted by mini-css-extract-plugin
export default {"gaudi":"gaudi-main_gaudi__dLT1c"};